import { Children, cloneElement, ReactElement, useRef } from 'react';
import noop from 'lodash/noop';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { SubcategoriesProps } from './types';

export const Subcategories = (props: SubcategoriesProps) => {
    const { value, onChange = noop, children, ...other } = props;
    const containerRef = useRef<HTMLDivElement | null>(null);

    return (
        <Box
            overflow="auto"
            position="relative"
            width="100%"
            borderBottom="1px solid var(--divider)"
            {...other}
        >
            <Flex
                ref={containerRef}
                direction="row"
                flexWrap="nowrap"
                role="tablist"
                width="fit-content"
                mx="auto"
            >
                {(Children.toArray(children) as Array<ReactElement<SubcategoriesProps>>).map(
                    (element) =>
                        cloneElement(element, {
                            'aria-selected': value === element.props.value,
                            onClick: () => onChange(element.props.value),
                        }),
                )}
            </Flex>
        </Box>
    );
};
